import { io } from "socket.io-client";

export const ordersSocket = io({
  path: "/socket.io",
  autoConnect: false,
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionDelay: 800,
  reconnectionDelayMax: 8_000,
});

export function joinOrderRooms(orderIds: number[]): void {
  if (!ordersSocket.connected) return;
  for (const orderId of orderIds) {
    ordersSocket.emit("join_order", { order_id: orderId });
  }
}
